// extracted by mini-css-extract-plugin
export default {"pageWrap":"Sa-z","fullWidth":"Ta-z","heading":"Ua-z","fullBleed":"Va-z","hidden":"Wa-z"};